import { getOriginalCounterPart } from "./clones";
import { getSlidesToSlide } from "./common";

/**
 * This produces a list of possible slides that dots can go to next.
 * @param {number} numberOfDotsToShow - The number of dots to display.
 * @param {object} state - The internal state of the carousel.
 * @param {object} props - The props of the carousel.
 * @param {Array<any>} childrenArr - An array of the carousel's children (slides).
 * @returns {object} A lookup table where keys are dot indices and values are the corresponding slide indices.
 */
function getLookupTableForNextSlides(
  numberOfDotsToShow,
  state,
  props,
  childrenArr
) {
  const table = {};
  const slidesToSlide = getSlidesToSlide(state, props);

  Array(numberOfDotsToShow)
    .fill(0)
    .forEach((_, i) => {
      const nextSlide = getOriginalCounterPart(i, state, childrenArr);
      if (i === 0) {
        table[0] = nextSlide;
      } else {
        const prevIndex = i - 1;
        const now = table[prevIndex] + slidesToSlide;
        table[i] = now;
      }
    });
  return table;
}

export { getLookupTableForNextSlides };